import React, { useState, useEffect } from 'react'
import '../css/Delivery/DeliveryDashboard.css';
import extraImg from '../assets/empty-cart.gif';
import Delivery1 from '../assets/delivery-img.gif';
import Delivery2 from '../assets/delivery1.gif';
import Delivery3 from '../assets/delivery2.gif';
import ProfileImg from '../assets/profile_img.png';
import ResponseMsg from '../general/ResponseMsg';
import Loading from '../general/Loading';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';


const DeliveryDashboard = ({ userData }) => {
    const [orders, setOrders] = useState([]);
    const [excOrders, setExcOrders] = useState([]);
    const [showUpdate, setShowUpdate] = useState(false);
    const [showExcUpdate, setShowExcUpdate] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState('');
    const [newStatus, setNewStatus] = useState('');
    const [paymentStatus, setPaymentStatus] = useState('');
    const [otp, setOtp] = useState('');
    const [response, setResponse] = useState(null);
    const [otpVerified, setOtpVerified] = useState(false);
    const [otpText, setOtpText] = useState(null);
    const [readableAddresses, setReadableAddresses] = useState({});
    const [loading, setLoading] = useState(false);

        const fetchOrders = async () => {
            setLoading(true);
            try {
                const response = await fetch(`https://api.kcmstore.in/store/get-assigned-order/${userData.id}`);
                setLoading(false);
                if (response.ok) {
                    const data = await response.json();
                    const sortedOrders = data.sort((a, b) => b.id - a.id);

                    const addressMap = {};
                    for (const order of sortedOrders) {
                        if (order.lat && order.longi) {
                            const address = await getReadableAddress(order.lat, order.longi);
                            addressMap[order.id] = address;
                        }
                    }

                    setOrders(sortedOrders);
setReadableAddresses(prev => ({ ...prev, ...addressMap }));
                } else {
                    console.error('Failed to fetch products');
                    setLoading(false);
                }
            } catch (error) {
                setLoading(false);
                console.error('Error fetching products:', error);
            }
        };


                const fetchExcOrders = async () => {
            setLoading(true);
            try {
                const response = await fetch(`https://api.kcmstore.in/store/get-exchange-assigned-order/${userData.id}`);
                setLoading(false);
                if (response.ok) {
                    const data = await response.json();
                    const sortedOrders = data.sort((a, b) => b.id - a.id);
                    console.log(sortedOrders);

                    const addressMap = {};
                    for (const order of sortedOrders) {
                        if (order.lat && order.longi) {
                            const address = await getReadableAddress(order.lat, order.longi);
                            addressMap[order.id] = address;
                        }
                    }

                    setExcOrders(sortedOrders);
setReadableAddresses(prev => ({ ...prev, ...addressMap }));
                } else {
                    console.error('Failed to fetch products');
                    setLoading(false);
                }
            } catch (error) {
                setLoading(false);
                console.error('Error fetching products:', error);
            }
        };

    useEffect(() => {


        fetchExcOrders();
        fetchOrders();
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    };


    const handleUpdateDialog = (order) => {
        setSelectedProduct(order);
        setShowUpdate(true);
    }


        const handleExcUpdateDialog = (order) => {
        setSelectedProduct(order);
        console.log(order);
        setShowExcUpdate(true);
    }


    const handleVerifyOtp = () => {
        if (otp === selectedProduct.otp) {
            setOtpVerified(true);
            setOtpText('OTP Verified Successfully');
        } else {
            setOtpVerified(false);
            setOtpText('Invalid OTP');
        }
    };


    const handleUpdateStatus = async (orderId, status, paymentStatus) => {

        if (newStatus === 'Delivered' && !paymentStatus) {
            setResponse("Please select the payment status.");
            setTimeout(() => {
                setResponse('');
            }, 2000)
            return;
        }

        if (newStatus === 'Delivered' && !otpVerified) {
            setResponse("Please verify the OTP.");
            setTimeout(() => {
                setResponse('');
            }, 2000)
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(`https://api.kcmstore.in/store/update-delivery-status/${orderId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    order_status: status,
                    payment_status: paymentStatus,
                }),
            });

            setLoading(false);

            if (response.ok) {
                const updatedOrder = await response.json();
                setOrders(prevOrders =>
                    prevOrders.map(order =>
                        order.id === orderId ? { ...order, order_status: status } : order
                    )
                );
                setShowUpdate(false);
                setResponse('Order status updated successfully.');
                setTimeout(() => {
                    setResponse('');
                }, 2000)
                fetchOrders();
            } else {
                setResponse('Failed to update order status');
                setTimeout(() => {
                    setResponse('');
                }, 2000)
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error updating order status:', error);
        }
    };


    const handleExcUpdateStatus = async (excId, status) => {

        if (newStatus === 'Delivered' && !otpVerified) {
            setResponse("Please verify the OTP.");
            setTimeout(() => {
                setResponse('');
            }, 2000)
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(`https://api.kcmstore.in/store/update-exchange-delivery-status/${excId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    req_status: status,
                }),
            });

            setLoading(false);

            if (response.ok) {
                const updatedOrder = await response.json();
                setExcOrders(prevOrders =>
                    prevOrders.map(order =>
                        order.id === excId ? { ...order, req_status: status } : order
                    )
                );
                setShowExcUpdate(false);
                setResponse('Order status updated successfully.');
                                fetchExcOrders();

                setTimeout(() => {
                    setResponse('');
                }, 2000)
            } else {
                setResponse('Failed to update order status');
                setTimeout(() => {
                    setResponse('');
                }, 2000)
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error updating order status:', error);
        }
    };

    const getReadableAddress = async (lat, lon) => {
        try {
            const response = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`);
            const data = await response.json();
            return data.display_name || 'Unknown location';
        } catch (error) {
            console.error('Error fetching address:', error);
            return 'Unable to fetch location';
        }
    };
    

    return (
        <>
            <section className='py-4 bg-light'>
                <div className='px-4'>

                    <div className='d-flex'>
                        <p className='sec-heading'>Agent Dashboard</p>
                        <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>Delivery</span></div>

                    <div className='row'>

                        <div className='col-lg-8 col-md-8 col-12 my-2'>
                            <div className='row'>

                                <div className='col-lg-6 col-12 my-2'>
                                    <div className='delivery-card'>
                                        <img src={Delivery1} className='delivery-card-img' alt='Delivery Card' />
                                        <div className='align-content-center'>
                                            <p className='delivery-text'>Orders Delivered</p>
                                            {/* <p className='delivery-num'>{orders.filter(order => order.order_status === 'Delivered').length}</p> */}
                                            <p className='delivery-num'>{
    orders.filter(order =>
        order.order_status === 'Delivered'
    ).length +
    excOrders.filter(order =>
        order.req_status === 'Delivered'
    ).length
}</p>

                                            </div>
                                    </div>
                                </div>

                                <div className='col-lg-6 col-12 my-2'>
                                    <div className='delivery-card'>
                                        <img src={Delivery2} className='delivery-card-img' alt='Delivery Card' />
                                        <div className='align-content-center'>
                                            <p className='delivery-text'>Orders Assigned</p>
<p className='delivery-num'>{
    orders.filter(order =>
        order.order_status === 'Assigned Delivery Partner' || order.order_status === 'Out for Delivery'
    ).length +
    excOrders.filter(order =>
        order.req_status === 'Assigned Delivery Partner' || order.req_status === 'Out for Delivery'
    ).length
}</p></div>
                                    </div>
                                </div>

                            </div>
                            {/* inner row ends */}

                            <p className='fw-bold fs-5 my-3'>Orders Assigned</p>

                            {orders.length > 0 ? (
                                orders.filter(order =>
                                    order.order_status === 'Assigned Delivery Partner' || order.order_status === 'Out for Delivery'
                                ).length > 0 ? (
                                    orders.filter(order =>
                                        order.order_status === 'Assigned Delivery Partner' || order.order_status === 'Out for Delivery'
                                    ).map((order) => {
                                        const orderItems = JSON.parse(order.order_items);
                                        const readableAddress = readableAddresses[order.id];
                                        return (
                                            <div className='my-3' key={order.id}>
                                                <div className='order-area'>
                                                    <p className='fw-semibold'>Order placed on {formatDate(order.order_date)}</p>
                                                    <p className='text-muted fw-semibold para-text'>
  Customer Name: {order.customer_name}<br />
  Mobile No: {order.customer_mobile}<br />
  Address: {order.latitude && order.longitude
    ? readableAddress
    : `${order.customer_address} ${order.customer_city} ${order.customer_state} ${order.customer_pincode}`}
</p>

<Swiper spaceBetween={20} slidesPerView={6} modules={[Navigation]} loop={true}
                      navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                      breakpoints={{
                        0: {
                          slidesPerView: 3,
                        },
                        768: {
                          slidesPerView: 3,
                        },
                        992: {
                          slidesPerView: 6,
                        }
                      }}>

                                                    {orderItems.length > 0 ? (
                                                        orderItems.map((item, index) => (
                                                            <>
                                                                <hr />
                                                                <SwiperSlide key={index} className='mt-3'>
                                                                    <img
                                                                        src={`https://api.kcmstore.in/sUploads/${item.image}`}
                                                                        className='img-fluid'
                                                                        alt='Order'
                                                                    />
<p className='mt-2 mb-0 para-text fw-semibold'>{item.product_name}</p>
                                                                        <span className='text-muted para-text'>{item.quantity} Item ₹{item.product_price * item.quantity}</span>
                                                                </SwiperSlide>
                                                            </>
                                                        ))
                                                    ) : (
                                                        <p>No items in this order</p>
                                                    )}
                                                    
                                                    </Swiper>

                                                    <p className='mt-3 text-muted fw-semibold para-text'>Payment Mode: {order.payment_mode}<br />Payment Status: {order.payment_status}</p>
                                                    <p className='text-muted fw-semibold'>Order Total ₹ {order.total_amount}<br />This Order has been {order.order_status}</p>

                                                    <div className='d-md-flex mt-3'>
                                                        <button className='order-btn mx-1 my-1 w-100' onClick={() => handleUpdateDialog(order)}>Update Delivery Status 🚛</button>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className='text-center'>
                                        <img src={extraImg} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10' alt='Staff' />
                                        <p>No New Orders Assigned yet</p>
                                    </div>
                                )
                            ) : (
                                <div className='text-center'>
                                    <img src={extraImg} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10' alt='Staff' />
                                    <p>No New Orders Assigned yet</p>
                                </div>
                            )}


{excOrders.length > 0 ? (
  excOrders.filter(order =>
    order.req_status === 'Assigned Delivery Partner' || order.req_status === 'Out for Delivery'
  ).length > 0 ? (
    excOrders.filter(order =>
      order.req_status === 'Assigned Delivery Partner' || order.req_status === 'Out for Delivery'
    ).map((order) => {
      const orderItems = JSON.parse(order.ex_items);
                  const grandTotal = orderItems.reduce((acc, item) => acc + Number(item.total_price), 0);
      const readableAddress = readableAddresses[order.id];
      return (
        <div className='my-3' key={order.id}>
          <div className='order-area'>
            <p className='fw-semibold'>Exchange Requested on {formatDate(order.req_on)}</p>
            <p className='text-muted fw-semibold para-text'>
              Customer Name: {order.customer_name}<br />
              Mobile No: {order.customer_mobile}<br />
              Address: {order.latitude && order.longitude
                ? readableAddress
                : `${order.customer_address} ${order.customer_city} ${order.customer_state} ${order.customer_pincode}`}
            </p>

<Swiper spaceBetween={20} slidesPerView={6} modules={[Navigation]} loop={true}
                      navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                      breakpoints={{
                        0: {
                          slidesPerView: 3,
                        },
                        768: {
                          slidesPerView: 3,
                        },
                        992: {
                          slidesPerView: 6,
                        }
                      }}>

                                                    {orderItems.length > 0 ? (
                                                        orderItems.map((item, index) => (
                                                            <>
                                                                <hr />
                                                                <SwiperSlide key={index} className='mt-2'>
<p className='mt-2 mb-0 para-text fw-semibold'>{item.name}</p>
                                                                        <span className='text-muted para-text'>{item.qty} Item | Price ₹{item.price} | Total ₹{item.total_price}</span>
                                                                </SwiperSlide>
                                                            </>
                                                        ))
                                                    ) : (
                                                        <p>No items in this order</p>
                                                    )}
                                                    
                                                    </Swiper>

                                                
                                                    <p className='text-muted fw-semibold'>Order Total ₹ {grandTotal}<br />This Order has been {order.req_status}</p>

                                                    <div className='d-md-flex mt-3'>
                                                        <button className='order-btn mx-1 my-1 w-100' onClick={() => handleExcUpdateDialog(order)}>Update Delivery Status 🚛</button>
                                                    </div>
          </div>
        </div>
      );
    })
  ) : (
    ''
  )
) : (
''
)}


                        </div>


                        <div className='col-lg-4 col-md-4 col-12 my-2 order-lg-last order-md-last order-first'>
                            <div className='delivery-card d-block text-center'>
                                <img src={ProfileImg} className='profile-img' alt="Profile" />
                                <p className='delivery-text mt-3 text-capitalize'>Delivery Agent {userData.name} </p>
                                <p className='text-muted fw-semibold'>Mobile No: {userData.phone}<br />Address: {userData.location}<br />{userData.city} {userData.state}</p>
                                <img src={Delivery3} className='profile-img' alt='Delivery Card' />
                            </div>
                        </div>


                    </div>
                    {/* row ends */}

                </div>
            </section>


            {showUpdate && (
                <>
                    <section className='delete-dialog px-3'>
                        <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-3 rounded-4'>
                            <p className='text-muted fw-semibold my-4'>Update Delivery Status</p>

                            <select
                                id="order-status"
                                className="form-select mb-4"
                                value={newStatus}
                                onChange={(e) => setNewStatus(e.target.value)}>
                                <option value="">Select status</option>
                                <option value="Out for Delivery">Out for Delivery</option>
                                <option value="Delivered">Delivered</option>
                            </select>

                            {newStatus === 'Delivered' && (
                                <>
                                    <select
                                        id="payment-status"
                                        className="form-select mb-4"
                                        value={paymentStatus}
                                        required={newStatus === 'Delivered'} // Add the required attribute dynamically
                                        onChange={(e) => setPaymentStatus(e.target.value)}>
                                        <option value="">Select payment status</option>
                                        <option value="pending">Pending</option>
                                        <option value="completed">Completed</option>
                                    </select>

                                    <div className='d-flex'>
                                        <input
                                            type="text"
                                            id="otp"
                                            className="form-control"
                                            placeholder="Enter OTP"
                                            value={otp}
                                            onChange={(e) => setOtp(e.target.value)}
                                        />
                                        &nbsp;&nbsp;
                                        <button
                                            className="success-btn col-md-3 col-5"
                                            onClick={handleVerifyOtp}
                                        >
                                            Verify OTP
                                        </button>
                                    </div>
                                    {otpText && <span className={`para-text fw-semibold ${otpVerified == true ? 'text-success' : 'text-danger'}`}>{otpText}</span>}<br /><br />

                                </>
                            )}

                            <button className='success-btn' onClick={() => handleUpdateStatus(selectedProduct.order_id, newStatus, paymentStatus)}>Yes</button>&nbsp;&nbsp;
                            <button className='danger-btn' onClick={() => setShowUpdate(false)}>No</button>
                        </div>
                    </section>
                </>
            )}


            {showExcUpdate && (
                <>
                    <section className='delete-dialog px-3'>
                        <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-3 rounded-4'>
                            <p className='text-muted fw-semibold my-4'>Update Delivery Status</p>

                            <select
                                id="order-status"
                                className="form-select mb-4"
                                value={newStatus}
                                onChange={(e) => setNewStatus(e.target.value)}>
                                <option value="">Select status</option>
                                <option value="Out for Delivery">Out for Delivery</option>
                                <option value="Delivered">Delivered</option>
                            </select>

                            {/* Conditionally show the payment status select box if order status is "Delivered" */}
                            {newStatus === 'Delivered' && (
                                <>
                                    <div className='d-flex'>
                                        <input
                                            type="text"
                                            id="otp"
                                            className="form-control"
                                            placeholder="Enter OTP"
                                            value={otp}
                                            onChange={(e) => setOtp(e.target.value)}
                                        />
                                        &nbsp;&nbsp;
                                        <button
                                            className="success-btn col-md-3 col-5"
                                            onClick={handleVerifyOtp}
                                        >
                                            Verify OTP
                                        </button>
                                    </div>
                                    {otpText && <span className={`para-text fw-semibold ${otpVerified == true ? 'text-success' : 'text-danger'}`}>{otpText}</span>}<br /><br />

                                </>
                            )}

                            <button className='success-btn' onClick={() => handleExcUpdateStatus(selectedProduct.exc_id, newStatus)}>Yes</button>&nbsp;&nbsp;
                            <button className='danger-btn' onClick={() => setShowExcUpdate(false)}>No</button>
                        </div>
                    </section>
                </>
            )}



            {response && <ResponseMsg message={response} />}
            {loading && <Loading setLoading={setLoading} />}

        </>
    )
}

export default DeliveryDashboard
